/**
 * Author(s) : Dhanush Kumaar
 * Purpose : This component is used to implement Stroke and Fill Animations.
 */

import React, { useEffect, useState } from 'react';
import $ from 'jquery';
import './LogoAnimation.scss';
import PropTypes from 'prop-types';

function LogoAnimation(props) {
  const { theme, isScreenSaver } = props;
  const [restart, setRestart] = useState(false);

  useEffect(() => {
    let logoBlock = $('.heroLogo');
    let logoPaths = $('.heroLogoPath');
    logoBlock.addClass('isAnimated');
    logoPaths.animate({ 'stroke-dashoffset': 0 }, 3500, function () {
      logoBlock.addClass('endAnimation');
      if (isScreenSaver) {
        setTimeout(function () {
          logoBlock.removeClass('endAnimation');
          logoBlock.removeClass('isAnimated');
          setRestart(!restart);
        }, 3600);
      } else {
        setTimeout(function () {
          $('body').addClass('isActive');
        }, 1700);
      }
    });
  }, [restart, isScreenSaver]);
  return (
    <>
      <div className="heroLogo">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          xmlnsXlink="http://www.w3.org/1999/xlink"
          width="996.01"
          height="185.4"
          viewBox="0 0 996.01 185.4">
          <defs>
            {theme === 'light' ? (
              <linearGradient
                id="linear-gradient"
                x1="-0.039"
                y1="0.432"
                x2="1.048"
                y2="0.418"
                gradientUnits="objectBoundingBox">
                <stop offset={0} stopColor="#E9A680" />
                <stop offset="0.526" stopColor="#CB4444" />
                <stop offset={1} stopColor="#064CB5" />
              </linearGradient>
            ) : (
              <linearGradient
                id="linear-gradient"
                x1="-0.039"
                y1="0.432"
                x2="1.048"
                y2="0.418"
                gradientUnits="objectBoundingBox">
                <stop offset={0} stopColor="#fff" />
                <stop offset="0.526" stopColor="#fff" />
                <stop offset={1} stopColor="#fff" />
              </linearGradient>
            )}
          </defs>

          <path
            className="heroLogoPath"
            id="Path_1879"
            data-name="Path 1879"
            d="M44.7-71.688l-4.738,16.48h34.4l-4.738-16.48Q66.332-82.4,63.345-93.73t-5.871-22.454H56.65q-2.678,11.33-5.665,22.557T44.7-71.688ZM-.412,0,43.466-134.724H71.482L115.36,0H90.228L79.722-36.462H34.4L23.9,0Zm153.47,2.472q-12.566,0-17.819-7.622t-5.253-20.806v-119.48h23.69V-24.72q0,4.326,1.648,6.077a4.8,4.8,0,0,0,3.5,1.751,10.939,10.939,0,0,0,1.545-.1l2.163-.309L165.624.412a29.552,29.552,0,0,1-5.253,1.442A38.764,38.764,0,0,1,153.058,2.472Zm55.826,0q-12.566,0-17.819-7.622t-5.253-20.806v-119.48H209.5V-24.72q0,4.326,1.648,6.077a4.8,4.8,0,0,0,3.5,1.751A10.939,10.939,0,0,0,216.2-17l2.163-.309L221.45.412A29.552,29.552,0,0,1,216.2,1.854,38.764,38.764,0,0,1,208.884,2.472Zm74.16,0a69.113,69.113,0,0,1-26.265-5.15A68.538,68.538,0,0,1,234.428-17.3l14.008-16.274a60.222,60.222,0,0,0,16.48,11.021,44.394,44.394,0,0,0,18.54,4.223q11.536,0,17.51-4.738a15.239,15.239,0,0,0,5.974-12.566q0-8.446-5.871-12.154a110.178,110.178,0,0,0-14.935-7.622l-18.54-8.034a69.935,69.935,0,0,1-12.875-7.416,36.252,36.252,0,0,1-10.3-11.536q-4.017-7-4.017-16.892a33.233,33.233,0,0,1,5.871-19.261,41.173,41.173,0,0,1,16.068-13.6,52.038,52.038,0,0,1,23.381-5.047,57.424,57.424,0,0,1,22.66,4.635A58.511,58.511,0,0,1,327.128-120.1l-12.154,15.244a55.276,55.276,0,0,0-13.493-8.446,39.113,39.113,0,0,0-15.759-3.09q-9.476,0-15.347,4.223a13.554,13.554,0,0,0-5.871,11.639,12.479,12.479,0,0,0,2.987,8.549,24.425,24.425,0,0,0,7.931,5.768q4.944,2.369,10.506,4.635l18.334,7.622a56.129,56.129,0,0,1,19.57,13.493q7.622,8.343,7.622,22.969a36.469,36.469,0,0,1-5.768,19.982A40.958,40.958,0,0,1,309.1-2.987Q298.288,2.472,283.044,2.472Zm70.864,37.492v-141.11h19.57l1.648,10.712h.824a71.189,71.189,0,0,1,14.317-9.27,36.174,36.174,0,0,1,16.171-3.914q18.952,0,29.355,14.008t10.4,37.492q0,17.3-6.18,29.561T424.051-3.914a37.909,37.909,0,0,1-21.115,6.386A31.71,31.71,0,0,1,389.752-.515,56.272,56.272,0,0,1,376.98-8.652L377.6,8.24V39.964ZM397.992-17.1q10.094,0,16.892-8.858t6.8-25.956q0-15.244-5.15-23.69t-16.686-8.446q-10.712,0-22.248,11.33v47.174a39.5,39.5,0,0,0,10.712,6.489A27.324,27.324,0,0,0,397.992-17.1Zm94.142,19.57q-13.184,0-21.527-8.24t-8.343-21.424q0-16.274,14.214-25.235T521.8-64.684a25.208,25.208,0,0,0-4.223-13.9q-4.017-5.871-14.317-5.871a38.3,38.3,0,0,0-14.523,2.884,97.663,97.663,0,0,0-13.9,7l-8.652-15.862a100.282,100.282,0,0,1,19.055-9.27,64.647,64.647,0,0,1,22.557-3.914q18.952,0,28.325,11.227t9.373,32.445V0h-19.57L524.27-11.124h-.824a74.313,74.313,0,0,1-14.523,9.682A36.613,36.613,0,0,1,492.134,2.472Zm7.622-18.54a21.629,21.629,0,0,0,11.227-2.987A70.548,70.548,0,0,0,521.8-27.192v-22.66q-20.6,2.678-28.634,7.931T485.13-29.046q0,6.8,4.12,9.888A17.033,17.033,0,0,0,499.756-16.068ZM573.916,0V-101.146h19.57l1.648,17.922h.824q5.356-9.888,12.978-15.141a27.278,27.278,0,0,1,15.656-5.253q7.21,0,11.536,2.06l-4.12,20.6a43.249,43.249,0,0,0-4.944-1.236,31.745,31.745,0,0,0-5.562-.412q-5.974,0-12.566,4.635T597.606-61.8V0Zm76.838,0V-145.436h23.278V-54.59h.618l37.492-46.556H738.1l-34.608,41.2L741.6,0H715.85L689.894-43.878,674.032-25.75V0ZM756.432-80.546l-5.768-10.506Q759.11-96,763.436-102.073t4.326-14.935a6.249,6.249,0,0,1-1.854.206,14.067,14.067,0,0,1-9.373-3.4,11.621,11.621,0,0,1-4.017-9.373q0-6.592,3.811-10.4a12.99,12.99,0,0,1,9.579-3.811q7.828,0,12.051,5.974t4.223,16.892Q782.182-93.936,756.432-80.546ZM801.34,0V-13.8q18.334-17.716,31.621-31.621t20.5-25.338q7.21-11.433,7.21-21.321,0-10.3-5.562-16.48t-16.068-6.18a23.98,23.98,0,0,0-13.905,4.326,65.56,65.56,0,0,0-11.639,10.3L800.31-113.3a74.938,74.938,0,0,1,18.746-14.935q9.682-5.253,23.072-5.253,18.952,0,30.179,10.918t11.227,29.252q0,11.536-6.489,23.587a139.678,139.678,0,0,1-17.3,24.617q-10.815,12.566-23.793,26.368,5.15-.412,11.124-.927t10.712-.515H889.92V0ZM907.018,0V-13.8q18.334-17.716,31.621-31.621t20.5-25.338q7.21-11.433,7.21-21.321,0-10.3-5.562-16.48t-16.068-6.18a23.98,23.98,0,0,0-13.905,4.326,65.56,65.56,0,0,0-11.639,10.3L905.988-113.3a74.938,74.938,0,0,1,18.746-14.935q9.682-5.253,23.072-5.253,18.952,0,30.179,10.918t11.227,29.252q0,11.536-6.489,23.587a139.678,139.678,0,0,1-17.3,24.617Q954.6-32.548,941.626-18.746q5.15-.412,11.124-.927t10.712-.515H995.6V0Z"
            transform="translate(0.412 145.436)"
            fill="url(#linear-gradient)"
          />
        </svg>
      </div>
    </>
  );
}

export default LogoAnimation;

LogoAnimation.propTypes = {
  theme: PropTypes.string,
  isScreenSaver: PropTypes.bool,
};
